<template>
    <div>
        <forms-grid :returnUrl="returnUrl"
                    :showSettingsBtn="true">
        </forms-grid>
    </div>
</template>

<script>
    import FormsGrid from "../../../../components/forms/FormsGrid";

    export default {
        name: 'list-forms-data',
        components: {
            FormsGrid
        },
        props: {
            showBtns: {
                default: true,
                type: Boolean
            },
            dateFormat: {
                default: 'dd-MM-yyyy HH:mm:ss',
                type: String
            }
        },
        data() {
            return {
                returnUrl: '/forms',
            };
        },
    }
</script>

<style scoped>
</style>
